import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Welcome from "./pages/Welcome";
import Workspace from "./pages/Workspace";
import AuthCallback from "./pages/AuthCallback";
import ErpRoute from "./pages/ErpRoute";
import "./index.css";

function AppRouter() {
  const location = useLocation();
  // Process a returning OAuth session_id FIRST (synchronously during render) to avoid races.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Welcome />} />
      <Route path="/erp" element={<ErpRoute><Workspace /></ErpRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
